var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65869 13.5027C6.85469 13.6074 7.10069 13.6067 7.29669 13.5021C12.638 10.6327 13.0174 5.02674 13.0127 3.43274C13.0122 3.30462 12.9743 3.17944 12.9037 3.07252C12.8332 2.96559 12.733 2.88157 12.6154 2.83074L7.24869 0.453405C7.16328 0.415758 7.07095 0.39637 6.97761 0.396485C6.88428 0.3966 6.792 0.416214 6.70669 0.454071L1.37735 2.8314C1.26148 2.88226 1.16268 2.96536 1.0927 3.07079C1.02273 3.17622 0.984542 3.29955 0.982686 3.42607C0.960019 5.01207 1.27935 10.6301 6.65869 13.5027ZM4.78269 5.86207L6.31135 7.39074L9.17335 4.52874L10.116 5.4714L6.31135 9.27607L3.84002 6.80474L4.78269 5.86207Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1ad08913b7864fdd69d35f22b5d2bbaf.svg";
export { ForwardRef as ReactComponent };